import React from "react";
import BannerNotificationAlerts from "Common/BannerNotificationAlerts/index.js";
import marketDefinitions from "Services/markets/marketsSvc.js";
import convertDateToCustomFormat from "Services/dateFormatter.js";
import { useFlags } from "launchdarkly-react-client-sdk";

export default function MaintenanceBanner({ currentMarket }) {
    const { maintenanceBanner } = useFlags();

    const rosettaAlterations = (rosettaMessage, activeFlag) => {
    
        if (!activeFlag) return "";
        if (!activeFlag.messageStartTime) return "";
        if (!activeFlag.messageDuration) return "";

        const dateFormat = marketDefinitions.getMarketDateFormat(currentMarket);
        const convertedDateTime = convertDateToCustomFormat(activeFlag.messageStartTime || "", dateFormat);

        const displayMessage = rosettaMessage
            .replace("{{duration}}", activeFlag.messageDuration.toString() || "")
            .replace("{{startTime}}", convertedDateTime);

        return displayMessage;
    };

    return (
        <BannerNotificationAlerts
            currentMarket={currentMarket}
            rosettaAlterations={rosettaAlterations}
            bannerFlagLD={maintenanceBanner}
            flagNameLD="maintenanceBanner"
        />
    );
}



// WEBPACK FOOTER //
// ./src/components/StartContainer/MaintenanceBanner/index.js